<template>
    <table :class="{ 'in-modal-table': inModal }" class="index-table">
        <thead>
            <tr class="no-hover">
                <th>Коэффициент</th>
                <th class="grey-column">Норма, %</th>
                <template v-if="years.length">
                    <th v-for="(y,i) in years" :key="i">{{y}}</th>
                </template>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(e,i) in list" :key="i">
                <td :class="{ 'fw-bold': inModal }" class="cursor-help" :title="e.descr">
                    {{e.label}}
                </td>
                <td class="grey-column">{{e.normalValue}}</td>
                <td 
                    v-for="(y,i) in years" 
                    :key="i" 
                    :class="checkValue(e.key, targetObj[y][e.key]) ? 'green' : 'red'"
                >
                    {{targetObj[y][e.key] ? targetObj[y][e.key] : '—'}}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>

export default {
    props: {
        years: {
            type: Array,
            default: []
        },
        targetObj: {
            type: Object,
            default: {}
        },
        inModal: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        list() { return this.$store.state.card?.businessIndex?.indexList }
    },
    methods: {
        checkValue(key, value) {
            switch(key) {
                case 'abs_liq':
                    return Number(value) >= 25
                case 'teq_liq':
                    return Number(value) >= 200
                case 'vosst_platezh':
                case 'finansir':
                    return Number(value) >= 100
                case 'fin_ustoych':
                case 'avtonom':
                case 'obesp_sob_obor_sr':
                    return Number(value) >= 50
                case 'manevr':
                    return Number(value) >= 10
                case 'sootn_sobstv_zaem_sr':
                    return Number(value) <= 70
                case 'kapitaliz':
                    return Number(value) <= 100
                case 'taxes_weight':
                    return Number(value) >= 11
                case 'insurance_weight':
                    return Number(value) >= 3.3
                default:
                    return false
                
            }
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.index-table
    @include lic-table
    tr
        td, th
            font-size: 13px
            &:not(:first-child)
                text-align: right
            &:first-child
                text-align: left
        th
            white-space: nowrap
        td
            font-weight: 300
        td.cursor-help
            cursor: help
        &.no-hover
            &:hover
                background: none
        .grey-column
            color: #bdc3c7 
        td.green
            color: #2ecc71
        td.red
            color: #e74c3c
table.in-modal-table
    tr
        td, th
            font-size: 14px
            border-bottom: 1px solid #ddd
        td.fw-bold
            font-weight: 700
        &:hover
            background: none
</style>